// extracted by mini-css-extract-plugin
export var cartIcon = "_lp-0";
export var cartIconContainer = "_lp-1";